import React from 'react';
import '../../../css/Grupo1/G1Landing.css';
import PsicologoF from '../../../Component/Grupo5/PsicologoF';


function Psicologo(){

return(
      <div  >
        <PsicologoF/>
      </div>

);


}
export default Psicologo;